import { combineReducers } from 'redux';
import entityUsage from './reducers/usage/entityUsage';
import filterUsage from './reducers/usage/filter/filter';
import authentication from './reducers/authentication';
import customers from './reducers/customers';
import charts from './reducers/charts';
import social from './reducers/social';
import entity from './reducers/entity';
import message from './reducers/message';
import glossary from './reducers/glossary';
import countries from './reducers/countries';
import genres from './reducers/genres';
import ageGroups from './reducers/ageGroups';
import exCountries from './reducers/exCountries';
import regions from './reducers/regions';
import selectedCustomers from './reducers/selectedCustomers';
import selectedSourceOfStreams from './reducers/selectedSourceOfStreams';
import topicFilters from './reducers/topicFilters';
import generalSettings from './reducers/generalSettings';
import userSettings from './reducers/userSettings';
import persistentSettings from './reducers/persistentSettings';
import physicalConfigurations from './reducers/physicalConfigurations';
import sourceOfStreamTypes from './reducers/sourceOfStreamTypes';
import subscriptions from './reducers/subscriptions';
import notificationModals from './reducers/notificationModals';
import myLists from './reducers/myLists';
import fullCharts from './reducers/fullCharts';
import browseTable from './reducers/user/browseTable';
import ownerTypes from './reducers/ownerTypes';
import actuality from './reducers/actuality';
import consulEnvData from './reducers/consul_parameters';
import faq from './reducers/faq';
import recentlyViewedUsage from './reducers/usage/viewed/viewedEntities';
import customRegions from './reducers/customRegions';
import customDSPLists from './reducers/customDSPLists';
import selectedCustomDSPList from './reducers/selectedCustomDSPList';
import playlistActivity from './reducers/playlistActivity';
import myPlaylists from './reducers/myPlaylists';

const reducers = {
  // global data
  entity,
  // editable data
  message,
  glossary,
  // default settings
  generalSettings,
  // user settings
  userSettings,
  persistentSettings,
  selectedCustomers,
  selectedSourceOfStreams,
  topicFilters,
  // notifications
  subscriptions,
  notificationModals,
  // user data
  authentication,
  // user recents
  entityUsage,
  filterUsage,
  // metadata
  customers,
  countries,
  exCountries,
  regions,
  genres,
  charts,
  social,
  physicalConfigurations,
  sourceOfStreamTypes,
  ageGroups,
  ownerTypes,
  // custom lists
  myLists,
  fullCharts,
  browseTable,
  actuality,
  faq,
  recentlyViewedUsage,
  customRegions,
  customDSPLists,
  selectedCustomDSPList,
  consulEnvData,
  playlistActivity,
  myPlaylists,
};

const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
